// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"156":"fffad871","213":"95c3641a","239":"3852e2fb","455":"50c43ca0"}[chunkId] + ".chunk.js";
};